import { CircularProgress } from "@mui/material";
import React from "react";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiBackdrop-root": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(0,0,0,0.55)"
        : "rgba(17,17,17,0.35)",
  },
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 8px 32px rgba(17,17,17,0.16)",
    borderRadius: 16,
    padding: 20,
  },
}));

const LoadingModal = () => {
  const loading = useSelector((st) => st?.global?.isLoading);

  return (
    <CustomDialog open={loading}>
      <CircularProgress sx={{ display: "flex" }} />
    </CustomDialog>
  );
};

export default LoadingModal;
